module.exports = __webpack_public_path__ + "img/map-location-xl-fr.717de95b.jpg";